"use client"
import React, { useEffect, useState } from "react"
import { StepHeader } from "./components/StepHeader"
import { useMediaQuery } from "@utils/hooks/useMediaQuery"
import { calculatePoints } from "./components/utils/calculatePoints"
import cn from "class-names"
import styles from "@css/modules/pointsGuide.module.scss"
import { Ellipse } from "@css/icons/SVG"
import { Step1 } from "./components/Step1"
import { Step2 } from "./components/Step2"
import { Step3 } from "./components/Step3"
import { Step4 } from "./components/Step4"
import { Step5 } from "./components/Step5"
import { Step6Header } from "./components/Step6Header"
import { Step6 } from "./components/Step6"

const maxSteps = 6

const steps = {
    1: {
        Component: Step1
    },
    2: {
        Component: Step2
    },
    3: {
        Component: Step3
    },
    4: {
        Component: Step4
    },
    5: {
        Component: Step5
    },
    6: {
        Header: Step6Header,
        Component: Step6
    }
}
export function ClientContent({ resorts }: { resorts: any }) {
    const [animation, setAnimation] = useState(false)
    const [step, setStep] = useState(1)
    const [next, setNext] = useState(0)
    const { title, Component = () => null, Header = StepHeader } = steps[step] || {}
    const [stepsData, setStepsData] = useState({
        1: null,
        2: null,
        3: null,
        4: null,
        5: null,
        6: 0
    })
    const onChange = (value) => {
        setStepsData({
            ...stepsData,
            [step]: value
        })
    }
    const changeStep = (to) => () => {
        setNext(to)
    }
    const mobile = useMediaQuery("(max-width: 992px)")
    useEffect(() => {
        if (next) {
            setAnimation(true)
            setTimeout(() => {
                if (next === 6) {
                    setStepsData({
                        ...stepsData,
                        6: calculatePoints(stepsData)
                    })
                }
                setStep(next)
                setNext(0)
                setAnimation(false)
                if (mobile) {
                    const content = document.querySelector("#scroll-target")
                    if (content) {
                        const bounding = content.getBoundingClientRect()
                        window.scrollBy({
                            top: bounding.top - 60,
                            left: 0,
                            behavior: "smooth"
                        })
                    }
                }
            }, 500)
        }
    }, [next, mobile])

    return (
        <div className={cn(styles.root, mobile && styles.mobile)}>
            <div className={styles.topContent}>
                <h1>{title || "Lets find the right number of points for you"}</h1>
                <div className={styles.currentStep}>
                    <span className={styles.stepText}>
                        {next || step}
                        <span className={styles.max}>/{maxSteps}</span>
                    </span>
                    <Ellipse className={styles.stepCircle} value={(100 / maxSteps) * step} circleClass={styles.stepCirclePath} />
                </div>
            </div>
            <Header goToStart={changeStep(1)} data={stepsData} mobile={mobile} />
            <div className={styles.animationWrapper}>
                <div
                    className={cn({
                        [styles.current]: true,
                        [styles.animation]: animation
                    })}>
                    <Component
                        mobile={mobile}
                        resorts={resorts}
                        data={stepsData}
                        lastValue={stepsData[step]}
                        onChange={onChange}
                        goNext={changeStep(step + 1)}
                        goBack={changeStep(step - 1)}
                    />
                </div>
            </div>
        </div>
    )
}
